import React, { useEffect } from "react";
import { connect } from "react-redux";
import Header from "../Components/Header/Header";
import Aside from "../Components/Aside/Aside";
import { useNavigate } from "react-router-dom";

const Home = ({ user, ...props }) => {
  let navigate = useNavigate();
  useEffect(() => {
    if (user?.role && [12, 13].includes(user?.role)) {
      navigate(`/ReportRoleWise`);
    }
    navigate(`/UpCommingEvents`);
  }, [user]);
  return (
    <div className="wrapper">
      <Header />
      <Aside />
      <div className="dashboard"></div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdate: (user) => dispatch({ type: "UPDATE_USER", data: user }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
